const ASCII_PATTERN = /^[\x20-\x7F\n]*$/;

const buildMessage = fieldName => `The ${fieldName} field can only include letters, numbers and some symbols.`;

export default {
    validate: value => {

        if (value && value.length) {
            return ASCII_PATTERN.test(value);
        }

        return true;

    },
    message: (fieldName = 'field') => buildMessage(fieldName)
};
